import { Grid, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import { REGISTER_CARD_TAB } from "app/common/LocalConst";
import {
  formatMoney,
  getDateTime,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import RegisterCardPopup from "../RegisterCardTab/Popup/RegisterCardPopup";
const ListCardBlock = ({
  initialPatient,
  setCurrentTab,
  handleAfterSubmit,
}) => {
  const {
    openCreateOrEditCardPopup,
    handleCloseCreateOrEditCardPopup,
    saveOrUpdateRegisterCard,
    initRegisterCard,
    openConfirmDelete,
    handleOpenConfirmDelete,
    handleDeleteCard,
    handleOpenCreateOrEditCardPopup,
  } = useStore().patientManagementStore.registerCardStore;
  const { listVatPercent } =
    useStore().patientManagementStore.patientGeneralStore;
  const { t } = useTranslation();
  const isReadonly = isRoleHisReadOnly();
  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        height: "100%",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Grid container spacing={1} className="m-0 w-100">
        <Grid item xs={12} className="search-title-card">
          <p className="title-block">Thẻ trả trước</p>
          <div className="flex align-center flex-end gap-1 cursor">
            <p
              className="button-more"
              onClick={() => setCurrentTab(REGISTER_CARD_TAB)}
            >
              Xem thêm
            </p>
          </div>
        </Grid>
        {(initialPatient?.prepaidCardList || []).length > 0 ? (
          (initialPatient?.prepaidCardList || []).map((row, index) => (
            <>
              <Grid
                key={index}
                item
                xs={12}
                style={{
                  borderBottom: "1px solid gray",
                  padding: "5px",
                  fontSize: "var(--fs-base)",
                }}
              >
                <div className="medical-container ">
                  <div className="text-medical-container">
                    <div>
                      <span className="text-medical">
                        {getDateTime(row?.startDate)}
                        {row?.endDate ? ` - ${getDateTime(row?.endDate)}` : ""}
                      </span>
                    </div>
                    <div className="flex flex-wrap items-center">
                      <span className="name-medical">
                        {row?.clientCard?.name}({formatMoney(row?.price)})
                      </span>
                      <div className="flex justify-center items-center">
                        <CloseIcon fontSize="inherit" />
                        <span className="value-medical">{row?.quantity}</span>
                      </div>

                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        <span>Giảm:</span>&nbsp;
                        <span className="value-medical">
                          {formatMoney(row?.discount)}
                        </span>
                      </div>

                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        <span>VAT:</span>&nbsp;
                        <span className="value-medical">
                          {formatMoney(+row?.taxTotal)}
                        </span>
                      </div>
                    </div>
                    {row?.staffRevenues?.length > 0 && (
                      <span
                        style={{
                          fontSize: "var(--fs-base-two)",
                          color: "#666",
                        }}
                      >
                        Nhân viên:
                        <b style={{ marginLeft: 4 }}>
                          {row.staffRevenues
                            .map(
                              (s) =>
                                `${s?.staff ? s.staff?.staffName : ""}  ${
                                  s?.staff ? `(${s?.staff?.code})` : ""
                                }`
                            )
                            .join(", ") || ""}
                        </b>
                      </span>
                    )}
                  </div>
                  <div className="flex justify-center items-center p-2 gap-4">
                    {!isReadonly && (
                      <>
                        <Tooltip title="Chỉnh sửa">
                          <div
                            onClick={() => {
                              handleOpenCreateOrEditCardPopup(row);
                            }}
                          >
                            <IconPen />
                          </div>
                        </Tooltip>
                        <Tooltip title="Xóa thẻ liệu trình">
                          <div
                            className="flex"
                            onClick={() => {
                              handleOpenConfirmDelete(row?.id);
                            }}
                          >
                            <IconDelete />
                          </div>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>
                <div className="flex mt-2">
                  <div>
                    Đã thu:{" "}
                    <b style={{ color: "green" }}>
                      {formatMoney(row?.totalBillPatientPaid || 0)}
                    </b>
                  </div>

                  <span className="mx-2 text-gray-400">|</span>
                  <div>
                    Cần thu:{" "}
                    <b style={{ color: "red" }}>
                      {formatMoney(
                        (row.amountActuallyPaid = row?.priceWithTax
                          ? +row?.price * +row?.quantity - (+row?.discount || 0)
                          : +row.price * +row?.quantity -
                            (+row?.discount || 0) +
                            (+row?.taxTotal || 0))
                      )}
                    </b>
                  </div>
                  <span className="mx-2 text-gray-400">|</span>
                  <div>
                    <b>Giá trị SD:</b>{" "}
                    <b style={{ color: "red" }}>
                      {formatMoney(row?.totalValue)}
                    </b>
                  </div>
                  <span className="mx-2 text-gray-400">|</span>
                  <div>
                    <b> Đã dùng:</b>{" "}
                    <b style={{ color: "green" }}>
                      {formatMoney(row?.totalUsed)}
                    </b>
                  </div>
                </div>
              </Grid>
            </>
          ))
        ) : (
          <div className="flex justify-center items-center w-full mt-5">
            Chưa có dữ liệu
          </div>
        )}
        {!!openCreateOrEditCardPopup && (
          <RegisterCardPopup
            open={!!openCreateOrEditCardPopup}
            handleClose={handleCloseCreateOrEditCardPopup}
            initRegisterCard={{
              ...initRegisterCard,
              patientId: initialPatient?.patientInfo?.id,
            }}
            onSubmit={async (values) => {
              await saveOrUpdateRegisterCard(values);
              handleAfterSubmit();
            }}
            patient={initialPatient?.patientInfo}
            listVatPercent={listVatPercent}
          />
        )}

        {openConfirmDelete && (
          <ConfirmPopup
            open={openConfirmDelete}
            onClose={() => handleOpenConfirmDelete(null)}
            text="Bạn có chắc chắn muốn hủy thẻ này không ?"
            onConfirm={async () => {
              await handleDeleteCard();
              handleAfterSubmit();
            }}
          />
        )}
      </Grid>
    </div>
  );
};

export default memo(observer(ListCardBlock));
